export const BASIC_UNIT_PRICE_CONSTANT =  0.3025

export const CUSTOM_POSTAL_CODES = {
  '733-0037': '広島県広島市西区西観音町',
  '230-0063': '神奈川県横浜市鶴見区鶴見',
  '270-0119': '千葉県流山市おおたかの森北',
  '132-0031': '東京都江戸川区松島'
}
